/**
 * Investment-related constants
 */

// Commitment status values
export const COMMITMENT_STATUS = {
  PENDING: 'pending',
  APPROVED: 'approved',
  CONFIRMED: 'confirmed',
  CONTRACTED: 'contracted',
  FUNDED: 'funded',
  ACTIVE: 'active',
  COMPLETED: 'completed',
  WITHDRAWN: 'withdrawn',
  REJECTED: 'rejected',
  CANCELLED: 'cancelled',
};

// Status labels for display
export const COMMITMENT_STATUS_LABELS = {
  [COMMITMENT_STATUS.PENDING]: 'Pending Approval',
  [COMMITMENT_STATUS.APPROVED]: 'Approved',
  [COMMITMENT_STATUS.CONFIRMED]: 'Confirmed',
  [COMMITMENT_STATUS.CONTRACTED]: 'Contracted',
  [COMMITMENT_STATUS.FUNDED]: 'Funded',
  [COMMITMENT_STATUS.ACTIVE]: 'Active',
  [COMMITMENT_STATUS.COMPLETED]: 'Completed',
  [COMMITMENT_STATUS.WITHDRAWN]: 'Withdrawn',
  [COMMITMENT_STATUS.REJECTED]: 'Rejected',
  [COMMITMENT_STATUS.CANCELLED]: 'Cancelled',
};

// Status colors for badges
export const COMMITMENT_STATUS_COLORS = {
  [COMMITMENT_STATUS.PENDING]: 'bg-yellow-100 text-yellow-800 border-yellow-200',
  [COMMITMENT_STATUS.APPROVED]: 'bg-blue-100 text-blue-800 border-blue-200',
  [COMMITMENT_STATUS.CONFIRMED]: 'bg-green-100 text-green-800 border-green-200',
  [COMMITMENT_STATUS.CONTRACTED]: 'bg-purple-100 text-purple-800 border-purple-200',
  [COMMITMENT_STATUS.FUNDED]: 'bg-indigo-100 text-indigo-800 border-indigo-200',
  [COMMITMENT_STATUS.ACTIVE]: 'bg-emerald-100 text-emerald-800 border-emerald-200',
  [COMMITMENT_STATUS.COMPLETED]: 'bg-green-100 text-green-800 border-green-200',
  [COMMITMENT_STATUS.WITHDRAWN]: 'bg-gray-100 text-gray-800 border-gray-200',
  [COMMITMENT_STATUS.REJECTED]: 'bg-red-100 text-red-800 border-red-200',
  [COMMITMENT_STATUS.CANCELLED]: 'bg-red-100 text-red-800 border-red-200',
};

// Investment percentage options (5% increments)
export const INVESTMENT_PERCENTAGE_OPTIONS = [
  5, 10, 15, 20, 25, 30, 35, 40, 45, 50,
  55, 60, 65, 70, 75, 80, 85, 90, 95, 100
];

// Minimum and maximum investors per property
export const MIN_INVESTMENT_PERCENTAGE = 5;
export const MAX_INVESTMENT_PERCENTAGE = 100;
export const MAX_INVESTORS_PER_PROPERTY = 20;

// Aliases for backward compatibility
export const INVESTMENT_STATUS = COMMITMENT_STATUS;
export const INVESTMENT_STATUS_LABELS = COMMITMENT_STATUS_LABELS;
export const INVESTMENT_STATUS_COLORS = COMMITMENT_STATUS_COLORS;
